<script setup lang="ts">
import { NotebookPenIcon } from 'lucide-vue-next'
import { useCollectsWithMissingFields } from '~/composables/collect/useCollectsWithMissingFields'

const { data: collectsWithMissingFields, isPending } = useCollectsWithMissingFields()
const { t } = useI18n()
const router = useRouter()

const handleCardClick = (action: string) => {
  router.push(action)
}
</script>

<template>
  <ActionCard
    :icon="NotebookPenIcon"
    :title="t('collect.waiting_for_informations', { count: collectsWithMissingFields?.length })"
    :subtitle="t('collect.waiting_for_informations_subtitle')"
    :badge="{ title: t('documents.todo'), type: 'warning' }"
    button-action="/collects/overview"
    :button-label="t('global.complete')"
    :is-loading="isPending"
    :is-visible="!!(collectsWithMissingFields?.length > 0)"
    @click="handleCardClick"
  />
</template>
